import { render, staticRenderFns } from "./TeacherLogsModal.vue?vue&type=template&id=9a58ce2a&scoped=true&"
import script from "./TeacherLogsModal.vue?vue&type=script&lang=js&"
export * from "./TeacherLogsModal.vue?vue&type=script&lang=js&"
import style0 from "./TeacherLogsModal.vue?vue&type=style&index=0&id=9a58ce2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a58ce2a",
  null
  
)

export default component.exports